import { render, staticRenderFns } from "./ReceiptType.vue?vue&type=template&id=968395d8&scoped=true"
import script from "./ReceiptType.vue?vue&type=script&lang=js"
export * from "./ReceiptType.vue?vue&type=script&lang=js"
import style0 from "./ReceiptType.vue?vue&type=style&index=0&id=968395d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968395d8",
  null
  
)

export default component.exports